import { render, staticRenderFns } from "./AskImprovementPropsWindow.vue?vue&type=template&id=7fc92eba&"
import script from "./AskImprovementPropsWindow.vue?vue&type=script&lang=js&"
export * from "./AskImprovementPropsWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QItem,QInput,QBtn,QTooltip,QSeparator,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign({QDialog,QCard,QCardSection,QItem,QInput,QBtn,QTooltip,QSeparator,QCardActions}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
